import { Icon24Company } from '@figma/fpl-icons';
import { fplIcon } from './fplIcon';
import type { SvgComponent } from '@/types/SvgComponent';

const CompanyIconLocal: SvgComponent = ({ title, ...props }) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      {title ? <title>{title}</title> : null}
      <path
        fill="currentColor"
        d="M12 5c.552 0 1 .448 1 1v11c0 .552-.448 1-1 1H7l-.103-.005A1 1 0 0 1 6 17V6c0-.552.448-1 1-1zm3.5 3c.276 0 .5.224.5.5V10h2c.552 0 1 .448 1 1v6c0 .552-.448 1-1 1h-3.5a.5.5 0 0 1 0-1H18v-6h-3.5a.5.5 0 0 1 0-1h.5V8.5c0-.276.224-.5.5-.5M7 17h1v-2c0-.552.448-1 1-1h1c.552 0 1 .448 1 1v2h1V6H7zm2 0h1v-2H9z"
      />
    </svg>
  );
};

export const CompanyIcon = fplIcon(CompanyIconLocal, Icon24Company);
